// Generated by ReScript, PLEASE EDIT WITH CARE


var addVectorTiles = (async function(map) {
      let maplibreGL = await import("@maplibre/maplibre-gl-leaflet")
      import("leaflet").then(L => {
        L.maplibreGL({
          style: "https://tiles.openfreemap.org/styles/liberty",
        }).addTo(map)
      })
  });

export {
  addVectorTiles ,
  
}
/* addVectorTiles Not a pure module */
